import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type OthersCatalogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OthersCatalogQuery = { __typename?: 'query_root', upfronts: Array<{ __typename?: 'items', id: number, properties?: Types.Maybe<any>, priceExcludingTax?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }> }>, websiteSetting?: Types.Maybe<{ __typename?: 'WebsiteSettingEntityResponse', data?: Types.Maybe<{ __typename?: 'WebsiteSettingEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'WebsiteSetting', isBlackFriday: boolean }> }> }>, othersCatalog?: Types.Maybe<{ __typename?: 'B2CSmartphoneOthersCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneOthersCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneOthersCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', id: string, entryName: string, isNew?: Types.Maybe<boolean>, formerUpfrontPriceInCentsInclundingTax?: Types.Maybe<number>, blackFridayFormerUpfrontPriceInCentsInclundingTax?: Types.Maybe<number>, subscriptionDrop?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSubscriptionDrop', formerSubscriptionPriceInCentsIncludingTax?: Types.Maybe<number>, formerUpfrontPriceInCentsIncludingTax?: Types.Maybe<number> }>>>, flagship?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, storage?: Types.Maybe<string>, colorName?: Types.Maybe<string>, combinedPicture?: Types.Maybe<{ __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', alternativeText?: Types.Maybe<string>, formats?: Types.Maybe<any> }> }> }>, smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string, brand?: Types.Maybe<string> }> }> }> }> }> }> }> }> }>, tags?: Types.Maybe<{ __typename?: 'TagRelationResponseCollection', data: Array<{ __typename?: 'TagEntity', attributes?: Types.Maybe<{ __typename?: 'Tag', name: string, slug: string }> }> }>, subscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', subscriptionItem?: Types.Maybe<{ __typename?: 'items', id: number, properties?: Types.Maybe<any>, priceExcludingTax?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }>, stock?: Types.Maybe<{ __typename?: 'devices_stock_view_cache', isOnline?: Types.Maybe<boolean> }> }>, smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, storage?: Types.Maybe<string>, colorName?: Types.Maybe<string>, colorCode?: Types.Maybe<string> }> }> }> }> }> }> }>>> }> }> }> };


export const OthersCatalogDocument = gql`
    query OthersCatalog {
  upfronts: items(
    where: {item_type: {_eq: "Upfront"}, _not: {properties: {_contains: {private: true}}}}
  ) {
    id
    properties
    priceExcludingTax: sell_price_in_cents_excl_tax
    tax {
      id
      amount
    }
  }
  websiteSetting {
    data {
      id
      attributes {
        isBlackFriday
      }
    }
  }
  othersCatalog: b2CSmartphoneOthersCatalog {
    data {
      attributes {
        catalogId
        entries {
          id
          entryName
          isNew
          formerUpfrontPriceInCentsInclundingTax
          blackFridayFormerUpfrontPriceInCentsInclundingTax
          subscriptionDrop {
            formerSubscriptionPriceInCentsIncludingTax
            formerUpfrontPriceInCentsIncludingTax
          }
          flagship {
            data {
              id
              attributes {
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      storage
                      colorName
                      combinedPicture {
                        data {
                          id
                          attributes {
                            alternativeText
                            formats
                          }
                        }
                      }
                      smartphoneFamily {
                        data {
                          id
                          attributes {
                            slug
                            brand
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          tags {
            data {
              attributes {
                name
                slug
              }
            }
          }
          subscriptions {
            data {
              id
              attributes {
                subscriptionItem {
                  id
                  properties
                  priceExcludingTax: sell_price_in_cents_excl_tax
                  tax {
                    id
                    amount
                  }
                  stock {
                    isOnline: is_online
                  }
                }
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      storage
                      colorName
                      colorCode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useOthersCatalogQuery(baseOptions?: Apollo.QueryHookOptions<OthersCatalogQuery, OthersCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OthersCatalogQuery, OthersCatalogQueryVariables>(OthersCatalogDocument, options);
      }
export function useOthersCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OthersCatalogQuery, OthersCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OthersCatalogQuery, OthersCatalogQueryVariables>(OthersCatalogDocument, options);
        }
export type OthersCatalogQueryHookResult = ReturnType<typeof useOthersCatalogQuery>;
export type OthersCatalogLazyQueryHookResult = ReturnType<typeof useOthersCatalogLazyQuery>;
export type OthersCatalogQueryResult = Apollo.QueryResult<OthersCatalogQuery, OthersCatalogQueryVariables>;